<template>
  <aside class="institutional-framework-page">
    <DocumentPageTitle
      :word-count="totalWords"
      :word-limit="wordLimit"
      title="Institutional Framework"
    />

    <template
      v-for="storeItem in storeItems"
      :key="storeItem.id"
    >
      <TextEditorInput
        :id="storeItem.id"
        v-model="planContentKey[storeItem.storeKey].text"
        :label="storeItem.label"
        :word-limit="wordLimit"
        :total-word-count="totalWords"
        @update:word-count="handleWordCountUpdate"
      />

      <DocumentAnnexureUploadButton :store-key="`institutionalFramework.${storeItem.storeKey}.documents`" />
    </template>
  </aside>
</template>

<script setup>
import { computed } from 'vue';
import { DocumentPageTitle } from '@/components/plan-document/components';
import { TextEditorInput } from '@/components/form-inputs';
import { useString, useTinyMCEWordCount } from '@/composables';
import { DocumentAnnexureUploadButton } from '@/components/plan-document/components';
import { usePlanStore } from '@/store';

const planStore = usePlanStore();
const string = useString();

const wordLimit = 3000;

const planContentKey = computed(() => {
  return planStore.content?.institutionalFramework || {};
});

const storeItems = [
  { label: 'Governance', storeKey: 'governance' },
  { label: 'Municipal structure', storeKey: 'municipalStructure' },
  { label: 'Skills requirements', storeKey: 'skillsRequirements' },
  { label: 'Strengths and weaknesses', storeKey: 'strengthsAndWeaknesses' },
  { label: 'Employment equity', storeKey: 'employmentEquity' },
].map(storeItem => ({ ...storeItem, id: string.sluggify(storeItem.label) }));

const storeItemIds = storeItems.map(storeItem => storeItem.id);

const {
  totalWords,
  updateCount,
} = useTinyMCEWordCount(wordLimit, storeItemIds);

const handleWordCountUpdate = ({ id, count }) => {
  updateCount(id, count);
};
</script>
